<template>
	<div class="">
		<div class="row">
			<div class="col-12">
				<div class="card mb-2">
					<div class="card-body pb-0">
						<!-- <div class="d-flex align-items-center justify-content-center">
							<h3 class="">Agenda de horários</h3>
						</div> -->
						<div class="row">
							<div class="col-10 col-lg-10 mb-3">
								<label><i class="fas fa-calendar-alt font-13 color-theme mr-1"></i><span class="font-14" > Data do dia</span></label>
								<input title="Mobile" class="form-control rounded" type="date" v-model="pesquisa.data" />
								<input title="Desktop" class="form-control rounded" type="date" v-model="pesquisa.data" />
							</div>
							<div class="col-2 col-lg-2 align-self-end mb-3">
								<button class=" btn btn-secondary w-100 rounded" @click="pesquisarUsuario()">
									<i class="fa fa-search font-13"></i>
								</button>
							</div>
							
						</div>
					</div>
					<div class="d-flex justify-content-center mb-1 font-italic font-14">
						<span v-if="lista.length == 1">{{lista.length + ' resultado encontrado'}}</span>
						<span v-else-if="lista.length > 1">{{lista.length + ' resultados encontrados'}}</span>
					</div>
				</div>
			</div>
		</div>

		<!-- Resultado da pesquisa -->
		<div v-if="lista.length > 0">
			<div class="cards">
				<div v-for="(u, index) in lista" :key="index" :index="index">
					<div class="card  mb-0 p-2">
						<div class="d-flex justify-content-between">
							<div class="justify-content-center">
								<div class="" v-if="u.dataAgendamento != ''">
									<span class="limitador mb-1 font-16">{{ u.nomeCompleto }}</span>
									<span class="limitador font-11 d-block font-16">
										<span class="color-theme mr-1">Horário:</span>{{ new Date(u.dataAgendamento).toLocaleString('pt-br', {minimumFractionDigits: 1, maximumFractionDigits:1, hour: 'numeric', minute: 'numeric',hour12: false}) }}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-body my-5 text-center font-16" v-else>Nenhum agendamento nessa data</div>
	</div>
</template>

<script>

// import moment from 'moment';
import $ from 'jquery'
import { mapState } from 'vuex'
import { ptBR } from 'vuejs-datepicker/dist/locale'

export default {
	name: 'Agenda',

	data() {
		return {
			ptBR: ptBR,
			pesquisa: {
				tipo: "nome",
				valor: ""
			},
			lista: [],
			tela_historico: "listar",
			historicos: [],
			historico_idAluno: 0,
			historico_temp: "",
			agendamento: 0,
			agendamento_data: "",
			agendamento_hora: "12:00",
			capelao: {},
			idUsuario: '',
			selecionou: {}
		}
	},
	computed: {
		...mapState({
			urlRest: state => state.urlRest,
			dadosUsuario: state => state.dadosUsuario,
			dadosEscola: state => state.dadosEscola,
		})
	},
   methods: {

	pesquisarUsuario: function () {
		let ref = this;
		this.$store.dispatch('alternarTelaCarregamento', true)

		this.$axios({
		method: 'get',
		url: this.urlRest + 'service/getAluno',
		params: {
			tipo: 'Agendamento',
			valor: this.pesquisa.valor,
			data: this.pesquisa.data,
			id: this.dadosUsuario.usuarioId,
			admin: this.dadosUsuario.usuarioAdmin,
			comunidade: 'Todos',
			idEscola: this.dadosEscola.id,
			pagina: 0
		}

		}).then(response => {
		ref.lista = response.data;
		console.log(ref.lista)
		for(let i = 0 ; i < ref.lista.length; i++) {
			console.log(ref.lista[i])
		}
		

		}).catch(function (error) {
		if (error.response != undefined) {
			if (error.response.status == 408) {
				ref.$store.dispatch('deslogar')

				ref.$toast.fire({
					icon: 'warning',
					title: 'Sessão expirada!'
				});
			} else {
				ref.$toast.fire({
					icon: 'error',
					title: 'Erro: ' + error.response.status
				});
			}
		} else {
			ref.$toast.fire({
				icon: 'error',
				title: error
			});
		}
		}).finally(() => {
			this.$store.dispatch('alternarTelaCarregamento', false)
		});
	},
	atualizarData() {
		const dataAtual = new Date().toISOString().substr(0, 10);
		this.pesquisa.data = dataAtual;
		// setTimeout(this.atualizarData, 5000); // Atualizar a cada segundo (opcional)
	},
	fecharModal: function() {
		this.selecionou = ''
		$('#modalHistorico').modal('hide')
		$('#modalCapelao').modal('hide')
	},
   },
   mounted() {
    // this.getDataAtual();
	this.atualizarData();
	this.pesquisarUsuario();
   },
   
}


</script>

<style scoped>

.aluno_card_image {
   width: 65px;
   float: left;
}

.aluno_card_corpo {
   margin-left: 75px;
}

.aluno_botao {
   right: 10px;
   top: 10px;
   position: absolute;
}

.aluno_botao button {
   margin: 3px;
   height: 60px;
   width: 60px;
}

.aluno_card_image img {
   width: 100%;
}


.switch input[type="checkbox"]:not(:checked)+.slider {
   background-color: #3c3e42
}

input[type="date"]::-webkit-calendar-picker-indicator {
   filter: invert(50%);
}

.slide-up-enter-active {
   transition: all 0.4s;
}

.slide-up-enter {
   transform: translateY(-100%);
   opacity: 0;
}

.slide-up-leave-to {
   transform: translateY(-100%);
   opacity: 0;
}

.custom-hover-class {
   background-color: red;
   color: white;
}

.ajusteBtn {
   margin-top: 32px;
}</style>